import script from "./index.vue?vue&type=script&setup=true&lang=jsx"
export * from "./index.vue?vue&type=script&setup=true&lang=jsx"

import "./index.vue?vue&type=style&index=0&id=ef0de25e&lang=css"
import "./index.vue?vue&type=style&index=1&id=ef0de25e&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef0de25e"]])

export default __exports__